import { motion } from "framer-motion";
import { ArrowDown, MapPin } from "lucide-react";

export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen flex items-end overflow-hidden">
      <img
        src="https://customer-assets-cm19k8pv.emergentagent.net/job_curry-bound-chase/artifacts/ha3q6g84_IMG_5478.webp"
        alt="Curry College purple turf endzone"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/60 to-zinc-950/20" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 pb-24 pt-40 w-full">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="font-sub text-xs sm:text-sm uppercase tracking-[0.3em] text-purple-300 mb-4 flex items-center gap-2"
        >
          <MapPin className="w-4 h-4" /> Curry College · Milton, Massachusetts · Fall 2026
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="font-display text-5xl sm:text-7xl lg:text-8xl tracking-tighter uppercase leading-[0.95] text-white"
        >
          Chase Takes<br />
          <span className="text-purple-400">The Purple Turf</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.35 }}
          className="font-sub text-base md:text-lg text-zinc-300 max-w-2xl mt-6"
        >
          After four incredible years at Our Lady of Lourdes and acceptance to over 30 colleges,
          Chase chose Curry — where he'll study Business Administration with a Pre-Law concentration
          and play football on the only purple field in college football. Help send him off right.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.45 }}
          className="flex flex-wrap gap-3 mt-6"
        >
          {["30+ College Acceptances", "Business Administration · Pre-Law", "Colonels Football"].map((chip) => (
            <span key={chip} className="font-sub text-xs font-semibold uppercase tracking-wider text-purple-200 bg-purple-950/60 border border-purple-500/40 backdrop-blur-sm px-4 py-2 rounded-full">
              {chip}
            </span>
          ))}
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="flex flex-wrap gap-4 mt-10"
        >
          <a
            href="#wishlist"
            data-testid="hero-wishlist-btn"
            className="font-sub font-semibold bg-purple-600 hover:bg-purple-500 text-white px-8 py-4 rounded-full transition-colors duration-200 drop-shadow-[0_0_20px_rgba(147,51,234,0.5)] active:scale-95"
          >
            View the Wish List
          </a>
          <a
            href="#wall"
            data-testid="hero-encourage-btn"
            className="font-sub font-semibold border border-white/20 hover:border-purple-400 text-white px-8 py-4 rounded-full transition-colors duration-200 backdrop-blur-sm active:scale-95"
          >
            Leave Encouragement
          </a>
        </motion.div>
      </div>
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <ArrowDown className="w-5 h-5 text-purple-400" />
      </div>
    </section>
  );
}
